<div class="department-map">
  <p class="department-map__hint">
    <strong>Explora por departamento.</strong> Selecciona un territorio en el mapa.
  </p>

  <div
    class="department-map__stage"
    aria-live="polite"
    (click)="onMapClick($event)"
    (keydown)="onMapKeydown($event)"
  >
    @if (svgResource.isLoading()) {
      <div class="department-map__loading" aria-label="Cargando mapa de Colombia"></div>
    } @else if (svgResource.error()) {
      <div class="department-map__error" role="alert">
        <p>No pudimos cargar el mapa. Puedes elegir el departamento en la lista.</p>
        <button type="button" (click)="svgResource.reload()">Reintentar</button>
      </div>
    } @else if (mapMarkup()) {
      <div class="department-map__vector" [innerHTML]="mapMarkup()"></div>
    }
  </div>

  <div class="department-map__panel">
    <p class="department-map__panel-title">Departamentos</p>
    <div class="department-map__grid">
      @for (department of availableDepartments(); track department.slug) {
        <button
          class="department-map__name"
          type="button"
          [class.is-selected]="isSelected(department)"
          [attr.aria-pressed]="isSelected(department)"
          (click)="selectDepartment(department)"
        >
          {{ department.name }}
        </button>
      }
    </div>
  </div>
</div>
